module.exports = __webpack_public_path__ + "static/img/22.966c4fcf.png";